import * as _m0 from "protobufjs/minimal";
import { GetUsersRequest, GetUsersResponse } from "../getusers";
import { withAuthRetry } from '../utils/authRetry';
import { UserType } from "../schema";
import { getServiceBaseUrl } from '../utils/api';

export async function getUsers(request: GetUsersRequest & { sortBy?: string, hideInternal?: boolean }, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<GetUsersResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const { baseUrl, stagingSuffix } = getServiceBaseUrl('adminservice');
        let url = `${baseUrl}/getusers${stagingSuffix}?offset=${request.offset}&page_size=${request.pageSize}&user_type=${UserType[request.userType]}`;

        // Add sort_by and hide_internal parameters for providers
        if (request.userType === UserType.PROVIDER) {
            if (request.sortBy) {
                url += `&sort_by=${request.sortBy}`;
            }
            if (request.hideInternal) {
                url += `&hide_internal=true`;
            }
        }

        const response = await fetch(
            url, {
            method: 'GET',
            headers,
        }
        );
        return response;
    };


    const decodeResponse = (bytes: Uint8Array): GetUsersResponse => {
        return GetUsersResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
